import { Injectable } from "@angular/core";

@Injectable({

    providedIn: "root",
})
export class AccordionService {
    private accordionState: Record<number, boolean> = {};

    public toggleAccordion(index: number): void {
        Object.keys(this.accordionState).forEach((key) => {
            if (parseInt(key, 10) !== index) {
                this.accordionState[parseInt(key, 10)] = false;
            }
        });

        this.accordionState[index] = !this.accordionState[index];
    }

    public getAccordionState(index: number): boolean {
        return this.accordionState[index] || false;
    }
}
